<section class="toolbar-container"
         [ngClass]="{'toolbar-container--with-back-button': displayBackButton}">
  <div class="toolbar-left"> <!-- BACK BUTTON -->
    <rappider-button *ngIf="displayBackButton"
                     [size]="toolbarBackButtonConfig.size ?? 'small'"
                     [text]="toolbarBackButtonConfig.text | translate"
                     [icon]="toolbarBackButtonConfig.icon"
                     (click)="onToolbarBackButtonClick()"></rappider-button>

  </div>
  <div class="toolbar-right">
    <rappider-button *ngFor="let button of toolbarButtons"
                     [size]="button.size ?? 'small'"
                     [text]="button.text"
                     [type]="button.type ?? 'default'"
                     [icon]="button.icon"
                     (click)="onToolbarButtonClick(button)"></rappider-button>
  </div>

</section>
